export const PROVIDER_ACCOUNT_HEADER = "provider-account-header";
export const PROVIDER_ACCOUNT_SITE_CERTIFIER_HEADER =
  "provider-account-site-certifier-header";
export const PROVIDER_ACCOUNT_PROVIDER_STAFF_HEADER =
  "provider-account-provider-staff-header";
export const ACCOUNT_TYPE_SITE_CERTIFIER = "Provider_Site_Certifier";
export const ACCOUNT_TYPE_PROVIDER_STAFF = "Provider_Staff";
export const PROVIDER_ACCOUNT_DESC = "provider-account-desc";
export const PROVIDER_INFO_FIRST_NAME = "provider-information-first-name";
export const PROVIDER_INFO_MIDDLE_NAME = "provider-information-middle-name";
export const PROVIDER_INFO_LAST_NAME = "provider-information-last-name";
export const PROVIDER_INFO_EMAIL = "provider-information-email";
export const PROF_LICENSE_NO = "profLicenseNo";
export const LICENSE_NUMBER_REQUIRED_ERROR =
  "professional-license-number-required-error";
export const LICENSE_NUMBER_LABEL = "professional-license-number-label";
export const LICENSE_NUMBER_HELPER_TEXT =
  "professional-license-number-helper-text";
export const PROVIDER_INFORMATION_HEADER = "provider-information-header";
export const SITE_CERTIFIER = "SITE-CERTIFIER";
export const DATE_OF_BIRTH = "dateOfBirth";
export const PROVIDER_SITE_INFO_USER_INFO_HEADING =
  "provider-site-information-user-info-heading";
export const PROVIDER_SITE_INFO_FIRST_NAME =
  "provider-site-information-first-name";
export const PROVIDER_SITE_INFO_REVIEW_HEADING =
  "provider-site-information-review-heading";
export const PROVIDER_SITE_INFO_MIDDLE_NAME =
  "provider-site-information-middle-name";
export const PROVIDER_SITE_INFO_LAST_NAME =
  "provider-site-information-last-name";
export const PROVIDER_SITE_INFO_EMAIL = "provider-site-information-email";
export const PROVIDER_SITE_INFO_EMAIL_LANGUAGE =
  "provider-site-information-email-language";
export const PROVIDER_SITE_INFO_HAS_PROF_LICENSE_NUMBER =
  "provider-site-information-has-prof-license-number";
export const PROVIDER_SITE_INFO_PROF_LICENSE_NUMBER =
  "provider-site-information-prof-license-number";
export const PROVIDER_SITE_INFO_DOB = "provider-site-information-dob";
export const PROVIDER_SITE_INFO_USER_NAME =
  "provider-site-information-username";
export const PROVIDER_SITE_INFO_PASSWORD = "provider-site-information-password";
export const PROVIDER_ACCOUNT_SETUP_HEADER = "provider-account-setup-header";
export const PASSWORD_VALIDATION_DEFAULT_RESPONSE = {
  errorResponse: "",
  successResponse: [],
};
export const USER_ROLE_STAFF = "STAFF";
export const LANGUAGE_CODE_113 = "113";
export const PROF_LICENSE_NO_RADIO_FIELD = "hasProfLicenseNo";
export const PROFESSIONAL_LICENSE_NUMBER_RADIO_FIELD_REQUIRED_ERROR =
  "professional-license-number-radio-field-required-error";
export const PROFESSIOANL_LICENSE_NUMBER_RADIO_LABEL =
  "professional-license-number-radio-field-label";
export const PROVIDER_REVIEW_CERTIFIER_SUB_TEXT =
  "provider-review-information-certifier-sub-text";
export const PROVIDER_REVIEW_STAFF_SUB_TEXT =
  "provider-review-information-staff-sub-text";
